import { render, staticRenderFns } from "./ExpandingButton.vue?vue&type=template&id=2042ac54&"
import script from "./ExpandingButton.vue?vue&type=script&lang=js&"
export * from "./ExpandingButton.vue?vue&type=script&lang=js&"
import style0 from "./ExpandingButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports